var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getParticipantsWithPastShiftsByMissionIdFunctionDef, } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useCallback } from 'react';
import useSWR from 'swr';
export const participantsWithPastShiftsByMissionIdFetchKey = 'participantsWithPastShiftsByMissionId';
export const useParticipantsWithPastShiftsByMissionId = ({ missionId, isVolunteerView, filterData, limit, offset, }) => {
    const getParticipantsWithPastShiftsByMissionIdPlatformFn = useTypedPlatformFunction(getParticipantsWithPastShiftsByMissionIdFunctionDef);
    const fetchParticipantsWithPastShiftsByMissionId = (missionId) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield getParticipantsWithPastShiftsByMissionIdPlatformFn({
            missionId,
            isVolunteerView,
            filterData,
            limit,
            offset,
        });
        return result;
    });
    const { data: listData, mutate, isLoading, error, } = useSWR([participantsWithPastShiftsByMissionIdFetchKey, missionId, isVolunteerView, limit, offset, filterData], ([, paramsMissionId]) => {
        return fetchParticipantsWithPastShiftsByMissionId(paramsMissionId).catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const fetchParticipantsWithPastShifts = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchParticipantsWithPastShifts,
        shiftsParticipants: listData === null || listData === void 0 ? void 0 : listData.rows,
        total: listData === null || listData === void 0 ? void 0 : listData.total,
        analytics: listData === null || listData === void 0 ? void 0 : listData.analytics,
        error,
        isLoading,
    };
};
